import { render, staticRenderFns } from "./NewListModal.vue?vue&type=template&id=4fbd0b6e&"
import script from "./NewListModal.vue?vue&type=script&lang=js&"
export * from "./NewListModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports